import { fetchGameFilterOptionsHandler } from '~/handlers/fetch-game-filter-options.handler';
import {
  STATIC_PROVIDERS,
  PROVIDER_SLUGS,
  type ProviderItem,
} from '@/utils/providerImages';

/**
 * Busca os providers na ordem da API /games/filter-options,
 * filtrando apenas os que possuem imagem em STATIC_PROVIDERS.
 * Fallback para STATIC_PROVIDERS se a API falhar.
 */
export const useOrderedProviders = () => {
  const providers = useState<ProviderItem[]>(
    'ordered-providers',
    () => STATIC_PROVIDERS,
  );

  const isLoading = useState<boolean>('ordered-providers-loading', () => true);
  const fetchPromise = useState<Promise<void> | null>(
    'ordered-providers-fetch-promise',
    () => null,
  );

  const hasFetched = useState<boolean>(
    'ordered-providers-has-fetched',
    () => false,
  );

  const fetchOrderedProviders = async () => {
    if (hasFetched.value) return;

    if (!fetchPromise.value) {
      fetchPromise.value = (async () => {
        try {
          isLoading.value = true;

          const { filterOptions } = await fetchGameFilterOptionsHandler();

          if (filterOptions?.providers?.length) {
            const ordered = filterOptions.providers
              .filter((p) => PROVIDER_SLUGS.includes(p.slug))
              .map((p) => ({ slug: p.slug }));

            if (ordered.length > 0) {
              providers.value = ordered;
            }
          }
        } catch (error) {
          console.error(
            '[useOrderedProviders] Erro ao buscar ordem dos providers:',
            error,
          );
        } finally {
          isLoading.value = false;
          hasFetched.value = true;
        }
      })();
    }

    await fetchPromise.value;
  };

  onMounted(() => {
    fetchOrderedProviders();
  });

  return {
    providers,
    isLoading,
  };
};
